import { render } from "./EgressRulesTab.vue?vue&type=template&id=3288b7b7&scoped=true"
import script from "./EgressRulesTab.vue?vue&type=script&lang=js"
export * from "./EgressRulesTab.vue?vue&type=script&lang=js"

import "./EgressRulesTab.vue?vue&type=style&index=0&id=3288b7b7&scoped=true&lang=scss"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3288b7b7"]])

export default __exports__